<p-table class="flat" [value]="items" (onRowReorder)="onRowReorder()">
    <ng-template #body let-col let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="checkbox-cell">
                <p-checkbox [(ngModel)]="col.visible" [binary]="true" (onChange)="onVisibilityChange()"></p-checkbox>
            </td>
            <td class="label-cell">{{col.label || col.header}}</td>
            <td class="drag-handle">
                <i class="pi pi-sort" pReorderableRowHandle></i>
            </td>
        </tr>
    </ng-template>
</p-table>
